import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Thankyou from "../assets/images/thank-you.png";
import { Link, useLocation } from "react-router-dom";

const ThankyouPageBooking = () => {
  const location = useLocation();
  const bookingNo = location.state?.bookingNo;

  return (
    <section className="section-padding">
      <Container>
        <Row>
          <Col lg="12" className="text-center">
            <div className="thankyou-card">
              <div className="image">
                <img src={Thankyou} alt="" />
              </div>
              <h2>Thank You for Your Enquiry!</h2>
              <div className="booking-id">
                Enquiry No: <span>{bookingNo}</span>
              </div>
              <p>
                Thank you for reaching out! Your request for a consultation has
                been successfully submitted. Our team will review your details
                and get in touch with you shortly .
              </p>
              <div className="greeting mb-5">Have a great day! 😊</div>
              <Link className="btn orange-btn" to={"/"}>
                Go to home
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ThankyouPageBooking;
